
export class CountySpendingUrls {
    public static DOWNLOAD_COUNTY_SPENDING_REPORT = '/api/v1/countyspendingreport/DownloadCountySpendingReport';
}
